import socialNetworks from "./social-networks";

export default class socialNetworksDesktop extends socialNetworks {
	constructor(...args) {
		super(...args);
	}
}



// WEBPACK FOOTER //
// src/js/components/social-networks/social-networks.desktop.js